import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';

type CopyToClipboardButtonProps = {
  text?: string | null;
  label?: string;
  size?: 'small' | 'medium';
  iconFontSize?: 'small' | 'medium' | 'inherit';
  tooltipTitle?: string;
};

export const CopyToClipboardButton = ({
  text,
  label = 'Copy',
  size = 'small',
  iconFontSize = 'small',
  tooltipTitle = 'Click to copy',
}: CopyToClipboardButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (text) {
        await navigator.clipboard.writeText(text);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to copy text:', err);
    }
  };

  return (
    <Tooltip title={copied ? 'Copied!' : tooltipTitle}>
      <span>
        <IconButton aria-label={label} onClick={handleCopy} size={size} disabled={!text}>
          {copied ? (
            <CheckIcon fontSize={iconFontSize} sx={{ color: 'success.main' }} />
          ) : (
            <ContentCopyIcon fontSize={iconFontSize} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
